import { getSessionUniversal } from "@/app/access/session";
import { clientPromiseEffect } from "@crm/effect/client/promise-effect";
import { browserEffectRuntime } from "@crm/effect/client/runtime";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { Effect } from "effect";
import { rpcCaller } from "@crm/rpc-client";
import { GroupInvitePublicRpc } from "@crm/rpc-contract/groups/groups";

function runGroupInviteRouteEffect<A, E>(effect: Effect.Effect<A, E>): Promise<A> {
  return browserEffectRuntime.runPromise(effect);
}

function loadGroupInviteRouteEffect(token: string) {
  return Effect.gen(function* () {
    // 检查用户是否已登录
    const session = yield* promiseEffect(() => loadSession());
    if (session?.user) {
      // 已登录，不应该访问此页面
      return yield* Effect.fail(
        redirect({
          to: "/",
          search: {
            error: "您已登录，无需重复注册",
          },
        }),
      );
    }

    const result = yield* promiseEffect(() =>
      groupInvitePublicRpc.validateInviteToken({
        token,
      }),
    );

    if (!result.success) {
      return yield* Effect.fail(
        redirect({
          to: "/login",
          search: {
            error: "服务器错误，请稍后重试",
          },
        }),
      );
    }

    if (!result.data?.valid) {
      return yield* Effect.fail(
        redirect({
          to: "/login",
          search: {
            error: result.data?.errorMessage || "邀请链接无效或已过期",
          },
        }),
      );
    }

    return result.data;
  });
}

const groupInvitePublicRpc = rpcCaller(GroupInvitePublicRpc);

const loadSession = () =>
  typeof window === "undefined"
    ? import("@tanstack/react-start/server").then(({ getRequest }) =>
        getSessionUniversal(getRequest().headers),
      )
    : getSessionUniversal();

function promiseEffect<A>(run: () => PromiseLike<A>) {
  return clientPromiseEffect("小组邀请注册失败", run);
}

export const Route = createFileRoute("/(auth)/group-invite/$token/")({
  head: () => ({
    meta: [{ title: "小组邀请 · imiker CRM" }],
  }),
  loader: ({ params }) => runGroupInviteRouteEffect(loadGroupInviteRouteEffect(params.token))
});
